export function useReadMore() {
  function readMore(rm) {
    const rm_wrap = rm.querySelector(".read-more__wrap");
    const rm_text = rm.querySelector(".read-more__text");
    const rm_button = rm.querySelector(".read-more__button");
    const rm_button_text = rm.querySelector(".read-more__button-text");

    const rm_text_height = rm_text.offsetHeight;
    rm_wrap.style.setProperty("--read_more_height", `${rm_text_height}px`);

    function toggle() {
      rm_wrap.classList.toggle("open");
      rm.classList.toggle("open");

      if (rm_wrap.classList.contains("open")) {
        rm_button_text.textContent = "Read less";
      } else {
        rm_button_text.textContent = "Read more";
      }
    }

    rm_button.addEventListener("click", toggle);
  }

  const read_more_items = document.querySelectorAll(".read-more");

  read_more_items.forEach((rm) => readMore(rm));
}
